<template>
    <div class="general-event-info">
        <div class="top-event-info">
            <div class="event-name">
                <div class="title">
                    <p>Title *</p>
                    <input v-model="eventTitle" placeholder="Enter event title" />
                </div>
                <div v-if="isMobile" class="event-image">
                    <p>Cover Image</p>
                    <div class="image-container" @click.once="uploadImage">
                        <img
                            :src="
                                getEventImage ? getEventImage : getIcon + 'Upload-Circle.png'
                            "
                            @click.self="uploadImage"
                            class="default-image"
                            :class="{
                                'upload-image': !!getEventImage
                            }"
                        />
                        <input
                            @change="selectFile($event)"
                            hidden
                            ref="photoUpload"
                            type="file"
                            class="photo-dwnld"
                        />
                    </div>
                </div>
                <div class="title">
                    <p>Add More Details</p>
                </div>
                <div class="budget-info">
                    <div class="budget-info-fields">
                        <div class="input-lable">
                            <span>Doors At*</span>
                            <div class="start-time-field">
                                <div
                                    @click="timeSelector.handleShowStartTime"
                                    class="time-field"
                                >
                                    <p class="event-time">{{ availability }}</p>
                                    <img
                                        :src="getIcon + 'timepicker-icon.png'"
                                        :class="{
                                            'rotate-arrow': timeSelector.showStartTime.value
                                        }"
                                    />
                                </div>
                                <div
                                    v-if="timeSelector.showStartTime.value"
                                    class="select-time"
                                >
                                    <div class="time-format-container">
                                        <p
                                            class="time-format"
                                            :class="{
                                                'selected-time-format':
                                                    timeSelector.selectTimeFormat.value
                                            }"
                                            @click="timeSelector.changeTimeFormat"
                                        >
                                            AM
                                        </p>
                                        <p
                                            class="time-format"
                                            :class="{
                                                'selected-time-format':
                                                    !timeSelector.selectTimeFormat.value
                                            }"
                                            @click="timeSelector.changeTimeFormat"
                                        >
                                            PM
                                        </p>
                                    </div>
                                    <div class="divider"></div>
                                    <div class="time-count">
                                        <p
                                            @click="timeSelector.setTime(time)"
                                            class="time"
                                            v-for="(time, index) in timeSelector.timeList
                                                .value"
                                            :key="index"
                                        >
                                            {{ time }}
                                            <span>{{ timeSelector.timeFormat.value }}</span>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="budget-info-fields">
                        <div class="budget-info-values">
                            <div class="input-lable">
                                <span>Cover Price</span>
                                <span class="cover-price-input">
                                    <span
                                        v-if="coverCost !== null && coverCost !== ''"
                                        class="dollar-sign"
                                    >
                                        $
                                    </span>
                                    <input
                                        v-model="coverCost"
                                        class="cover-cost-value"
                                        name="cover-cost"
                                        type="number"
                                        placeholder="$5"
                                    />
                                </span>
                            </div>
                        </div>
                    </div>
                    <div class="budget-info-fields">
                        <div class="budget-info-values">
                            <div class="input-lable">
                                <span>Minimum Age</span>
                                <input v-model="minAge" type="number" placeholder="18" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div v-if="!isMobile" class="event-image">
                <p>Cover Image</p>
                <div class="image-container" @click.once="uploadImage">
                    <img
                        :src="getEventImage ? getEventImage : getIcon + 'Upload-Circle.png'"
                        @click.self="uploadImage"
                        class="default-image"
                        :class="{
                            'upload-image': !!getEventImage
                        }"
                    />
                    <input
                        @change="selectFile($event)"
                        hidden
                        ref="photoUpload"
                        type="file"
                        class="photo-dwnld"
                    />
                </div>
            </div>
        </div>
        <div class="event-desc-container">
            <p class="event-desc-title">Event Description *</p>
            <p
                :class="
                    eventDescription.length > 500
                        ? 'event-desc-counter error-text'
                        : 'event-desc-counter'
                "
            >
                {{ eventDescriptionCount }}
            </p>
            <textarea
                class="event-desc-input"
                v-model="eventDescription"
                type="text"
                placeholder="Add event description here"
            />
            <p v-if="eventDescription.length > 500" class="mb-0 error-text">
                You have exceeded the maximum number of characters in this text field.
            </p>
        </div>
        <div :class="{ 'disabled-btn': disabledSaveBtn }" class="btn-container">
            <button :disabled="disabledSaveBtn" @click="updateEventData">Save</button>
        </div>
    </div>
</template>

<script>
    import useTimeSelector from '@/composables/useTimeSelector.js'
    import useCheckScreen from '@/composables/useCheckScreen.js'
    import axios from 'axios'
    import moment from 'moment'
    import { notification } from '../../../helpers/notification'
    export default {
        name: 'EditEventModal',
        props: {
            event: {
                required: true,
                type: Object
            }
        },
        emits: ['action-completed'],
        data: () => ({
            image: null,
            value: [],
            selectedOption: '',
            eventDate: '',
            datepickerOptions: {
                format: 'D, MM dd',
                language: 'en'
            },
            suggestedTags: ['Lounge', 'Romantic', 'Great for dining'],
            exampleTags: ['Lounge', 'Romantic', 'Great for dining'],
            eventTitle: '',
            eventDescription: '',
            minAge: '',
            coverCost: '',
            duration: 0
        }),
        methods: {
            uploadImage() {
                this.$refs.photoUpload.click()
            },
            selectFile(event) {
                const file = event.target.files[0]

                const reader = new FileReader()

                reader.onloadend = () => {
                    this.image = reader.result
                    this.uploadImageRequest()
                }

                reader.readAsDataURL(file)
            },
            uploadImageRequest() {
                if (this.event.image !== this.image) {
                    axios
                        .put('/event/manage/update/' + this.event.id, { image: this.image })
                        .then((response) => {
                            notification('success', response.data.message)
                            this.$emit('action-completed', {
                                image: this.image,
                                id: this.event.id
                            })
                        })
                        .catch((error) => {
                            notification('error', error)
                        })
                }
            },
            getEventStartDate(start) {
                if (!start) return undefined
                return start.includes('T') ? start.split('T')[0] : start.split(' ')[0]
            },
            getEventStartTime(event) {
                if (event.start_time) {
                    this.timeSelector.startTime.value = event.start_time.split(' ')[0]
                    this.timeSelector.timeFormat.value = event.start_time.split(' ')[1]
                } else {
                    const parsedTime = moment.utc(event.start)
                    this.timeSelector.startTime.value = parsedTime.format('h:mm')
                    this.timeSelector.timeFormat.value = parsedTime.format('A')
                }
            },
            checkEventDate() {
                if (this.event.title) this.eventTitle = this.event.title
                if (this.event.cover_cost) this.coverCost = this.event.cover_cost
                if (this.event.min_age) this.minAge = this.event.min_age
                if (this.event.description) this.eventDescription = this.event.description
                if (this.event.start) {
                    this.eventDate = this.getEventStartDate(this.event.start)
                    this.getEventStartTime(this.event)
                }
            },
            async updateEventData() {
                try {
                    const payload = {
                        start: this.eventDate,
                        duration: this.event.duration,
                        event_name: this.eventTitle,
                        start_time: this.availability,
                        description: this.eventDescription,
                        cover_cost: this.coverCost ? this.coverCost : null,
                        min_age: this.minAge ? this.minAge : null
                    }

                    const response = await axios.put(
                        '/api/event/manage/update/' + this.event.id,
                        payload
                    )
                    notification('success', response.data.message)
                    this.$emit('action-completed', {
                        ...payload,
                        id: this.event.id
                    })
                    this.$bvModal.hide('modal-edit-event')
                } catch (error) {
                    notification('error', error)
                }
            }
        },
        watch: {
            duration: function (duration) {
                if (duration) {
                    ;[this.timeSelector.endTime.value, this.timeSelector.timeFormatEnd.value] =
                        this.timeSelector.calculateEndTime(duration)
                } else {
                    this.timeSelector.resetSetTimeAndDuration()
                }
            },
            'timeSelector.startTime.value': function () {
                this.duration = this.timeSelector.calculateDuration()
            },
            'timeSelector.endTime.value': function () {
                this.duration = this.timeSelector.calculateDuration()
            }
        },
        computed: {
            disabledSaveBtn() {
                return (
                    !this.availability ||
                    !this.eventTitle ||
                    !this.eventDescription ||
                    this.eventDescription.length > 500
                )
            },
            getSuggestedTags() {
                return this.suggestedTags
            },
            limitedValue() {
                return this.value
            },
            getEventImage() {
                return this.image ? this.image : this.event.image
            },
            getIcon() {
                return '/images/'
            },
            availability() {
                return `${this.timeSelector.startTime.value} ${this.timeSelector.timeFormat.value}`
            },
            endingAvailability() {
                return `${this.timeSelector.endTime.value} ${this.timeSelector.timeFormatEnd.value}`
            },
            eventDescriptionCount: (self) => `${self.eventDescription.length} / 500`
        },
        setup() {
            const {
                timeList,
                timeListEnd,
                startTime,
                endTime,
                timeFormat,
                timeFormatEnd,
                showStartTime,
                showEndTime,
                selectTimeFormat,
                selectTimeFormatEnd,
                resetSetTimeAndDuration,
                calculateDuration,
                calculateEndTime,
                changeTimeFormat,
                changeEndTimeFormat,
                setTime,
                setEndTime,
                handleShowStartTime,
                handleShowEndTime
            } = useTimeSelector()

            const { isMobile } = useCheckScreen()

            return {
                isMobile,
                timeSelector: {
                    timeList,
                    timeListEnd,
                    startTime,
                    endTime,
                    timeFormat,
                    timeFormatEnd,
                    showStartTime,
                    showEndTime,
                    selectTimeFormat,
                    selectTimeFormatEnd,
                    resetSetTimeAndDuration,
                    calculateDuration,
                    calculateEndTime,
                    changeTimeFormat,
                    changeEndTimeFormat,
                    setTime,
                    setEndTime,
                    handleShowStartTime,
                    handleShowEndTime
                }
            }
        },
        mounted() {
            this.checkEventDate()
        }
    }
</script>

<style scoped lang="scss">
    @media (max-width: 600px) {
        .general-event-info {
            gap: 16px;
            .top-event-info {
                flex-wrap: wrap;

                .event-name {
                    flex: 0 1 100% !important;

                    .title {
                        margin-top: 3px;
                        gap: 16px;

                        p {
                            font-size: 20px !important;
                        }
                    }
                }

                .event-image {
                    width: 100%;
                    flex: 0 1 100% !important;

                    p {
                        font-size: 20px !important;
                    }

                    .image-container {
                        min-height: 200px;
                    }
                }
            }
            .event-desc-container {
                .event-desc-title {
                    font-size: 20px !important;
                }
            }
            .budget-info {
                flex-wrap: wrap;
                gap: 16px !important;

                .budget-info-fields {
                    width: 100%;

                    .budget-info-values {
                        width: 100%;
                        flex-wrap: wrap;
                    }

                    .input-lable {
                        max-width: none !important;
                        width: 100%;

                        input,
                        .cover-price-input {
                            width: 100%;
                            max-width: none !important;
                        }
                    }
                }
            }
        }
    }
    .general-event-info {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        gap: 40px;
        max-width: 895px;

        .top-event-info {
            display: flex;
            width: 100%;
            justify-content: space-between;

            .event-name {
                display: flex;
                flex-direction: column;
                align-items: flex-start;
                justify-content: space-between;
                gap: 40px;
                flex: 0 1 65%;
                max-width: 519px;

                .title {
                    display: flex;
                    flex-direction: column;
                    gap: 24px;
                    width: 100%;
                }

                .title p {
                    color: #dedede;
                    font-family: 'Instrument Sans';
                    font-size: 32px;
                    font-style: normal;
                    font-weight: 500;
                    line-height: 120%;
                    letter-spacing: -0.64px;
                    margin: 0;
                }

                .title input {
                    padding: 12px 16px 16px 16px;
                    border-radius: 12px;
                    border: 1px solid #8b8b8b;
                    background: #262626;
                    color: #dedede;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                    font-family: 'Instrument Sans';
                    font-size: 16px;
                    font-style: normal;
                    font-weight: 550;
                    line-height: 125%;
                }
            }

            .event-image {
                display: flex;
                flex-direction: column;
                align-items: flex-start;
                gap: 24px;
                flex: 0 1 35%;

                p {
                    color: #dedede;
                    font-family: 'Instrument Sans';
                    font-size: 26px;
                    font-style: normal;
                    font-weight: 500;
                    line-height: 120%;
                    letter-spacing: -0.52px;
                    margin: 0;
                }

                .image-container {
                    min-width: 100%;
                    min-height: 212px;
                    flex: 1 0 0;
                    border-radius: 12px;
                    border: 1px solid #8b8b8b;
                    background: #262626;
                    position: relative;
                    cursor: pointer;

                    .upload-image {
                        object-fit: cover;
                        width: 100%;
                        height: 100%;
                    }
                    .default-image {
                        position: absolute;
                        top: 50%;
                        left: 50%;
                        transform: translate(-50%, -50%);
                        border-radius: 12px;
                    }
                }
            }
        }

        .more-details-title {
            color: #dedede;
            font-family: 'Instrument Sans';
            font-size: 26px;
            font-style: normal;
            font-weight: 500;
            line-height: 120%;
            letter-spacing: -0.52px;
            margin: 0;
        }

        .budget-info {
            display: flex;
            gap: 32px;
            align-items: flex-end;

            .budget-info-fields {
                display: flex;
                flex-direction: column;
                gap: 24px;

                .budget-info-values {
                    display: flex;
                    gap: 24px;
                }

                .input-lable {
                    display: flex;
                    flex-direction: column;
                    gap: 6px;
                    max-width: 152px;

                    span {
                        color: #8b8b8b;
                        font-family: Instrument Sans;
                        font-size: 12px;
                        font-style: normal;
                        font-weight: 650;
                        line-height: 135%;
                        letter-spacing: 0.12px;
                    }
                    .cover-price-input {
                        color: #dedede;
                        font-family: 'Instrument Sans';
                        font-size: 20px;
                        font-style: normal;
                        font-weight: 550;
                        line-height: 120%;
                        letter-spacing: -0.2px;
                        padding: 12px 20px 15px 20px;
                        border-radius: 12px;
                        border: 1.5px solid #8b8b8b;
                        background: #262626;
                        max-width: 172px;
                        max-height: 65px;
                        display: flex;
                        flex-direction: row;
                        align-items: center;

                        .dollar-sign {
                            color: #dedede;
                            font-family: 'Instrument Sans';
                            font-size: 20px;
                            font-style: normal;
                            font-weight: 550;
                            line-height: 120%;
                            letter-spacing: -0.2px;
                        }
                        .cover-cost-value {
                            position: relative;
                            color: #dedede;
                            overflow: hidden;
                            text-overflow: ellipsis;
                            font-family: 'Instrument Sans';
                            font-size: 20px;
                            font-style: normal;
                            font-weight: 550;
                            line-height: 120%;
                            letter-spacing: -0.2px;
                            border: none;
                            background: none;
                            padding-top: 20px;
                            padding-left: 5px;
                        }

                        .cover-cost-value:focus {
                            outline: none;
                            border: none;
                            box-shadow: none;
                        }
                    }
                }

                .start-time-field,
                .end-time-field {
                    position: relative;
                }

                .time-field {
                    cursor: pointer;
                    display: flex;
                    padding: 12px 12px 16px 16px;
                    align-self: stretch;
                    border-radius: 12px;
                    border: 1px solid #8b8b8b;
                    background: #262626;
                    min-width: 152px;
                    min-height: 65px;
                    justify-content: space-between;
                    align-items: center;
                }

                .event-time {
                    color: #dedede;
                    font-family: 'Instrument Sans';
                    font-size: 12px;
                    font-style: normal;
                    font-weight: 650;
                    line-height: 120%;
                    margin: 0;
                }

                .select-time {
                    z-index: 1;
                    position: absolute;
                    padding: 8px 8px 12px 8px;
                    display: flex;
                    flex-direction: column;
                    gap: 8px;
                    border-radius: 12px;
                    background: #333;
                    box-shadow: 0 6px 12px -4px rgba(0, 0, 0, 0.5);
                    top: 50px;
                    left: 0;
                    max-height: 200px;
                    min-width: 150px;
                }

                .select-time::-webkit-scrollbar {
                    display: none;
                }

                .time-format-container {
                    display: flex;
                    justify-content: center;
                    align-items: flex-start;
                    gap: 8px;
                    align-self: stretch;
                }

                .time-format {
                    display: flex;
                    padding: 4px 8px;
                    justify-content: center;
                    align-items: center;
                    flex: 1 0 0;
                    border-radius: 6px;
                    margin: 0;
                    font-family: 'Instrument Sans';
                    font-size: 18px;
                    font-style: normal;
                    font-weight: 650;
                    line-height: 120%;
                    color: #8b8b8b;
                    cursor: pointer;
                }
                .selected-time-format {
                    background: #cdeb09;
                    color: #121212;
                }

                .time-count::-webkit-scrollbar {
                    width: 8px;
                }
                .time-count::-webkit-scrollbar-track {
                    background-color: none;
                }
                .time-count::-webkit-scrollbar-thumb {
                    max-height: 64px;
                    border-radius: 8px;
                    background: #8b8b8b;
                }
                .time-count {
                    display: flex;
                    flex-direction: column;
                    overflow-y: scroll;
                    gap: 8px;
                }

                p {
                    color: #dedede;
                    font-family: 'Instrument Sans';
                    font-size: 26px;
                    font-style: normal;
                    font-weight: 500;
                    line-height: 120%;
                    letter-spacing: -0.52px;
                    margin: 0;
                }

                input {
                    padding: 12px 16px 16px 16px;
                    border-radius: 12px;
                    border: 1px solid #8b8b8b;
                    background: #262626;
                    color: #dedede;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                    font-family: 'Instrument Sans';
                    font-size: 16px;
                    font-style: normal;
                    font-weight: 550;
                    line-height: 125%;
                    max-width: 170px;
                }
            }
        }

        .event-desc-container {
            .event-desc-title {
                margin: 0;
                color: #dedede;
                font-family: 'Instrument Sans';
                font-size: 32px;
                font-style: normal;
                font-weight: 500;
                line-height: 120%;
                letter-spacing: -0.64px;
            }
            .event-desc-counter {
                color: #646464;
                font-family: 'Instrument Sans';
                font-size: 12px;
                font-style: normal;
                font-weight: 650;
                line-height: 135%;
                letter-spacing: 0.12px;
                text-align: right;
                margin-bottom: -16px;
            }
            .error-text {
                color: #f03232;
            }
            .event-desc-input {
                max-width: 895px;
                width: 100%;
                height: 100px;
                padding: 12px 15px 15px 15px;
                border-radius: 12px;
                border: 1.5px solid #8b8b8b;
                background: #262626;
                color: #dedede;
                font-family: 'Instrument Sans';
                font-size: 16px;
                font-style: normal;
                font-weight: 550;
                line-height: 125%;
            }
        }
        .event-desc-container,
        .vibe-container {
            display: flex;
            flex-direction: column;
            gap: 24px;
            width: 100%;

            .suggested-tags {
                display: flex;
                align-items: center;
                align-content: center;
                gap: 10px;
                align-self: stretch;
                flex-wrap: wrap;

                .vibe-title {
                    color: #acacac;
                    text-overflow: ellipsis;
                    font-family: 'Instrument Sans';
                    font-size: 20px;
                    font-style: normal;
                    font-weight: 550;
                    line-height: 120%;
                    letter-spacing: -0.2px;
                    margin: 0;
                }

                .selected-vibes {
                    color: #dedede;
                    text-overflow: ellipsis;
                    font-family: 'Instrument Sans';
                    font-size: 20px;
                    font-style: normal;
                    font-weight: 550;
                    line-height: 120%;
                    letter-spacing: -0.2px;
                    margin: 0;
                }

                .suggested-vibe {
                    padding: 7px 30px 9px 30px;
                    border-radius: 100px;
                    border: 1px solid #8b8b8b;
                    background: #262626;
                    color: #8b8b8b;
                    font-family: 'Instrument Sans';
                    font-size: 16px;
                    font-style: normal;
                    font-weight: 550;
                    line-height: 125%;
                    margin: 0;
                    cursor: pointer;
                }

                .suggested-vibe:hover {
                    color: #000000;
                    background: #cdeb09;
                }

                .suggested-vibe-selected {
                    padding: 7px 30px 9px 30px;
                    border-radius: 100px;
                    font-family: 'Instrument Sans';
                    font-size: 16px;
                    font-style: normal;
                    font-weight: 550;
                    line-height: 125%;
                    margin: 0;
                    cursor: pointer;
                    border: 1px solid #cdeb09;
                    color: #cdeb09;
                }
            }

            .vibe-title {
                color: #dedede;
                font-family: 'Instrument Sans';
                font-size: 26px;
                font-style: normal;
                font-weight: 500;
                line-height: 120%;
                letter-spacing: -0.52px;
            }

            input {
                border-radius: 12px;
                border: 1px solid #8b8b8b;
                background: #262626;
                padding: 12px 16px 16px 16px;
                color: #dedede;
                text-overflow: ellipsis;
                white-space: nowrap;
                font-family: 'Instrument Sans';
                font-size: 16px;
                font-style: normal;
                font-weight: 550;
                line-height: 125%;
            }
        }

        .disabled-btn {
            opacity: 0.6;
        }

        .btn-container {
            width: 100%;

            button {
                padding: 11px 30px 12px 30px;
                border-radius: 100px;
                background: #cdeb09;
                color: #000;
                font-family: 'Instrument Sans';
                font-size: 18px;
                font-style: normal;
                font-weight: 550;
                line-height: 120%;
                width: 100%;
                border: 0;
            }
        }
    }
</style>
